export function getUploadErrorMessage(errorCode, t){
    switch(errorCode){
      case 8000:
        return {"Title": t('UndefinedErrorTitle'), "Description": t('UndefinedError')};
      case 8100:
        return {"Title": t('FileNotReadableTitle'), "Description": t('FileNotReadable')};
      case 8101:
        return {"Title": t('FileHasNoGeometryTitle'), "Description": t('FileHasNoGeometry')};
      case 8200:
        return {"Title": t('ZIPNotReadableTitle'), "Description": t('ZIPNotReadable')};
      case 8300:
        return {"Title": t('FileInfectedTitle'), "Description": t('FileInfected')};
      case 8400:
        return {"Title": t('WrongFBXFormatTitle'), "Description": t('WrongFBXFormat')};
      case 8500:
        return {"Title": t('RapidConversionFailedTitle'), "Description": t('RapidConversionFailed')};
      default:
        return {"Title": t('UndefinedErrorTitle'), "Description": t('UndefinedError')};
    }
};
